<template>
  <v-card>
    <v-btn absolute flat fab small class="close-btn" @click="$emit('close')">x</v-btn>
    <v-flex xs12 text-xs-center py-3 class="last-order-modal">
      Order History #
      ({{lastOrder.short ? lastOrder.short : lastOrder.id}})
    </v-flex>
    <v-flex xs12 v-if="err">
      <v-alert :value="true" type="error">{{err}}</v-alert>
    </v-flex>
    <v-data-table
      :headers="headers"
      :items="trackingHistory"
    >
      <template slot="items" slot-scope="props">
        <td>{{props.index + 1}}</td>
        <td>{{props.item.historyId}}</td>
        <td>{{props.item.system}}</td>
        <td>{{formatDate(props.item.createdOn)}}</td>
        <td>{{props.item.status}}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    props: ['lastOrder'],
    data() {
      return {
        err: '',
        headers: [
          {text: this.$lang.header.srNo, value: 'index', align: 'left', sortable: false,},
          {text: this.$lang.header.historyId, value: 'historyId', align: 'left', sortable: false,},
          {text: this.$lang.header.system, value: 'system', align: 'left', sortable: false,},
          {text: this.$lang.labels.created, value: 'createdOn', align: 'left', sortable: false,},
          {text: this.$lang.labels.status, value: 'status', align: 'left', sortable: false,},
        ],
        trackingHistory: [],
      };
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
    },
    created() {
      this.$http.get(`webshoporder/trackinghistory/${this.lastOrder.id}`)
        .then((res) => {
          if(res.body.status === 'Success') {
            this.trackingHistory = res.body.trackingHistory;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    },
  };
</script>

<style lang="scss" scoped>
  .last-order-modal {
    font-size: 22px;
  }
  .close-btn {
    right: 10px;
    top: 10px;
  }
</style>



// WEBPACK FOOTER //
// LastOrderModal.vue?ca87ce2a